import React from 'react';
import { useSelector } from 'react-redux';

const Header = () => {
  const { totalCount } = useSelector((state) => state.adminPanelUsers);
  return (
    <div className="adminPanel__header">
      <h5>
        Clinic Users List: <strong>{totalCount}</strong>
      </h5>
    </div>
  );
};

export default Header;
